var _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 199,
    viewBox: "0 0 363 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363 177C363 189.15 353.15 199 341 199C328.85 199 319 189.15 319 177V99C319 86.8497 328.85 77 341 77C353.15 77 363 86.8497 363 99V177Z",
    fill: "#060607"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181,
    cy: 171.5,
    rx: 27,
    ry: 27.5,
    fill: "#535C83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99 1C131.066 1 159.571 16.2452 177.663 39.8828C165.898 56.7909 159 77.3399 159 99.5C159 114.212 162.041 128.213 167.527 140.91C156.018 146.142 148 157.87 148 171.5C148 176.115 148.919 180.511 150.582 184.512C135.56 193.701 117.9 199 99 199C44.3238 199 0 154.676 0 100C0 45.3238 44.3238 1 99 1ZM264 0C318.676 0 363 44.3238 363 99C363 153.676 318.676 198 264 198C244.894 198 227.053 192.586 211.925 183.211C213.265 179.565 214 175.62 214 171.5C214 152.998 199.225 138 181 138C178.374 138 175.819 138.312 173.37 138.9C167.989 126.695 165 113.196 165 99C165 44.3238 209.324 0 264 0ZM99 45C68.6243 45 44 69.6243 44 100C44 130.376 68.6243 155 99 155C109.249 155 118.842 152.196 127.057 147.314L112.196 128.578C104.647 119.059 106.243 105.221 115.763 97.6709C125.282 90.1209 139.121 91.7169 146.671 101.236L153.188 109.455C153.721 106.383 154 103.224 154 100C154 69.6243 129.376 45 99 45ZM264 44C233.624 44 209 68.6243 209 99C209 129.376 233.624 154 264 154C294.376 154 319 129.376 319 99C319 68.6243 294.376 44 264 44Z",
    fill: "#060607"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/QA.d621c609560325694f51590d9a622d2f.svg";
export { ForwardRef as ReactComponent };